import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Button, CircularProgress, Stack, Slide } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useContent } from '../../../../context/ContentContext';
import axiosInstance from '../../../../utils/axiosInstance';

const AddressDisplay = () => {
    const { addresses, loading } = useContent();

    // State to control feedback message visibility
    const [copiedAddressId, setCopiedAddressId] = useState(null); // Track the copied address

    // Function to copy address to clipboard and show temporary feedback
    const handleCopy = (address, id) => {
        console.log("Address copied:", address); // Log address to the console
        navigator.clipboard.writeText(address);
        setCopiedAddressId(id);  // Set copied address ID to show feedback
        setTimeout(() => {
            setCopiedAddressId(null); // Hide feedback after 2 seconds
        }, 2000); // 2-second feedback timeout
    };

    // Helper function to get the full URL for the image
    const getImageUrl = (photoPath) => {
        if (!photoPath) return null;
        return `${axiosInstance.defaults.baseURL}/${photoPath}`;
    };

    // Show loading spinner if data is being fetched
    if (loading) {
        return (
            <Stack
                sx={{ width: '100%', height: '100vh', justifyContent: 'center', alignItems: 'center' }}
                direction="column"
            >
                <CircularProgress />
            </Stack>
        );
    }

    // Handle case when addresses are not available
    if (!addresses || addresses.length === 0) {
        return (
            <Stack
                sx={{ width: '100%', height: '100vh', justifyContent: 'center', alignItems: 'center' }}
                direction="column"
                spacing={2}
            >
                <Typography variant="h6">Tidak ada cabang yang tersedia</Typography>
                <img
                    src="/images/NoResultFound.webp"
                    alt="No Branch found"
                    style={{ width: '300px', height: 'auto' }}
                />
            </Stack>
        );
    }

    return (
        <Stack spacing={3} sx={{ p: 2 }}>
            {addresses.map((branch) => (
                <Card
                    key={branch.id}
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' }, // Stack vertically on mobile
                        alignItems: 'center',
                        padding: 2,
                    }}
                >
                    {/* Branch Image */}
                    <Typography variant="h6" gutterBottom>
                        {branch.name}
                    </Typography>

                    <img
                        src={getImageUrl(branch.photo)}
                        alt={branch.name}
                        style={{
                            width: "100%",
                            height: 100,
                            objectFit: 'cover',
                            borderRadius: 8,
                            marginBottom: { xs: '16px', sm: '0' }, // Add margin on mobile
                        }}
                    />
                    {/* Branch Details */}
                    <CardContent sx={{ flex: 1, textAlign: { xs: 'center', sm: 'left' } }}>
                        <Typography variant="body1" color="text.secondary">
                            {branch.address}
                        </Typography>
                    </CardContent>
                    {/* Copy Button */}
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        startIcon={<ContentCopyIcon />}
                        onClick={() => handleCopy(branch.address, branch.id)}
                    >
                        Copy
                    </Button>

                    {/* Temporary feedback message */}
                    {copiedAddressId === branch.id && (
                        <Typography
                            variant="body2"
                            color="success.main"
                            sx={{ marginTop: 1, textAlign: 'center', color: 'green' }}
                        >
                            Alamat {branch.name} berhasil di-copy!
                        </Typography>
                    )}
                </Card>
            ))}
        </Stack>
    );
};

export default AddressDisplay;
